module.exports = __webpack_public_path__ + "static/img/ic-home-select-crowd.3e5151d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-home-select-crowd.png
// module id = mDeb
// module chunks = 1